<template>
  <div>
    <v-container>
      <div class="text-xs-right mb-4">
        <importxlsx :loading="importloading" @onChange="onImport"></importxlsx>
        <v-btn @click="addBranch" color="primary">
          <span>Add Branch</span>
        </v-btn>
      </div>
      <div class="text-xs-center mt-4s">
        <v-btn
          @click="active = 'all'"
          :color="checkActive('all') ? 'primary' : 'grey'"
          :outline="!checkActive('all')"
          >All</v-btn
        >
        <v-btn
          @click="active = 'GRAM Pancakes'"
          :color="checkActive('GRAM Pancakes') ? 'primary' : 'grey'"
          :outline="!checkActive('GRAM Pancakes')"
          >Gram</v-btn
        >
        <v-btn
          @click="active = 'PABLO Cheese Tart'"
          :color="checkActive('PABLO Cheese Tart') ? 'primary' : 'grey'"
          :outline="!checkActive('PABLO Cheese Tart')"
          >Pablo</v-btn
        >
        <v-btn
          @click="active = 'KOF'"
          :color="checkActive('KOF') ? 'primary' : 'grey'"
          :outline="!checkActive('KOF')"
          >Kof</v-btn
        >
      </div>
      <div>
        <v-data-table
          expand
          hide-actions
          :loading="loading"
          :headers="headers"
          :items="filteredLocation"
          class="elevation-1 scgallrenttable"
        >
          <template v-slot:items="props">
            <tr>
              <td style="cursor: pointer" @click="showQrcode(props.item)">
                <em style="font-size: 21px" class="fas fa-qrcode" />
              </td>
              <td>{{ props.item.refno ? props.item.refno : '-' }}</td>
              <td>{{ props.item.phone_number ? props.item.phone_number : '-' }}</td>
              <td>{{ props.item.branch ? props.item.branch : '-' }}</td>
              <td>{{ props.item.details ? props.item.details : '-' }}</td>
              <td>
                <v-btn
                  flat
                  fab
                  small
                  color="primary"
                  class="ma-0"
                  @click="onEditBranch(props.item)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn
                  flat
                  fab
                  small
                  color="primary"
                  class="ma-0"
                  @click="onDeleteBranch(props.item.id)"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>

      <v-dialog v-model="branchDialog" width="550px" persistent>
        <BranchModal
          v-model="dataBranch"
          @close="onCloseBranchDialog"
          @success="onSuccessBranchDialog"
          :location="location"
          :action="actionDialog"
        >
        </BranchModal>
      </v-dialog>

      <!-- QR Code -->
      <v-dialog v-model="qrdialog" width="550px" persistent>
        <v-card class="text-xs-center pb-4">
          <div class="text-xs-right">
            <v-btn @click="qrdialog = false" icon small>
              <v-icon>close</v-icon>
            </v-btn>
          </div>
          <div style="font-size: 28px; font-weight: 600; color: lightseagreen">
            {{ qrdata.brand }}
          </div>
          <div style="color: darkgrey">
            {{ qrdata.branch }}
          </div>
          <vue-qr
            :size="200"
            :callback="getQRlink"
            class="mx-auto"
            :text="qrdata.refno"
            qid="testid"
            :whiteMargin="false"
          ></vue-qr>
          <div>
            <a v-if="qrlink" download="filename.jpeg" :href="qrlink">
              <v-btn color="primary" @click="gotolink">Download</v-btn></a
            >
          </div>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import api from '@/api'
import importxlsx from '@/components/elements/importxlsx.vue'
import axios from 'axios'
import VueQr from 'vue-qr'
import { mapGetters } from 'vuex'
import BranchModal from './BranchModal.vue'

export default {
  components: {
    VueQr,
    importxlsx,
    BranchModal
  },
  data() {
    return {
      qrdialog: false,
      qrdata: { refno: '' },
      qrlink: '',
      loading: false,
      active: 'all',
      location: [],
      headers: [
        { text: '', value: '', align: 'center', sortable: false },
        { text: 'Refno', value: 'refno', align: 'center' },
        { text: 'Phone number', value: 'phone_number', align: 'center' },
        { text: 'Branch', value: 'branch', align: 'center' },
        { text: 'Detail', value: 'details', align: 'center' },
        { text: '', value: '', align: 'center' }
      ],
      importloading: false,
      branchDialog: false,
      actionDialog: '',
      dataBranch: ''
    }
  },
  mounted() {
    this.getLocation()
  },
  computed: {
    ...mapGetters(['selectedBot']),
    filteredLocation() {
      return this.location.filter((el) => {
        if (this.active == 'all') {
          return true
        } else {
          return this.active == el.brand
        }
      })
    }
  },
  methods: {
    gotolink() {
      this.$nextTick(() => {
        console.log(this.qrlink)
        window.location.href = this.qrlink
      })
      // location.assign(this.qrlink)
    },
    getQRlink(link) {
      this.qrlink = link
    },
    showQrcode(item) {
      this.qrdialog = true
      this.qrdata = item
    },
    onImport(item) {
      this.importloading = true
      var data = {
        pageid: this.selectedBot.pageid,
        files: item[0]
      }
      api.postGPKlocationImport(data, async (err, response) => {
        this.importloading = false
        if (response && response.responsecode == 200) {
          await this.$swal.fire({
            text: 'สำเร็จ',
            type: 'success'
          })
          this.getLocation()
        } else {
          await this.$swal.fire({
            text: 'ข้อมูลไม่ถูกต้อง'
          })
        }
      })
    },
    addBranch() {
      this.branchDialog = true
      this.actionDialog = 'add'
    },
    onEditBranch(item) {
      this.dataBranch = item
      this.branchDialog = true
      this.actionDialog = 'edit'
    },
    onDeleteBranch: function (id) {
      let vm = this
      vm.$swal
        .fire({
          title: 'Do you want to delete this ?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then((result) => {
          if (result.value) {
            var data = {
              pageid: vm.selectedBot.pageid,
              id: id
            }
            api.deleteGPKlocation(data, function (error, response) {
              if (error) {
                console.error(error)
                return
              }

              if (response && response.responsecode == 200) {
                vm.getLocation()
              } else {
                vm.$swal.fire({
                  text: response.reason
                })
              }
            })
          }
        })
    },
    onSuccessBranchDialog() {
      this.getLocation()
    },
    onCloseBranchDialog() {
      this.branchDialog = false
      this.dataBranch = ''
      this.actionDialog = ''
    },
    getLocation() {
      var vm = this
      vm.loading = true
      axios
        .get('https://api-gpf-hr.zwiz.app/' + 'gpklocation', {
          headers: {
            AUTHORIZATION: 'Bearer xxx xxx'
          },
          params: {
            pageid: this.selectedBot.pageid
          }
        })
        .then((response) => {
          vm.loading = false
          if (response.data.responsecode == 200) {
            this.location = response.data.data
          }
        })
    },
    checkActive(item) {
      return this.active == item
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/grampablokof/Branch.vue